import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Link from 'components/common/Link';
import IconPlus from 'components/icons/IconPlus';

const styles = theme => ({
  root: {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    margin: '0 0 0 16px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 8,
    },
  },
  link: {
    textTransform: 'uppercase',
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 10,
    },
    marginRight: 16,
  },
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 13,
  },
});

const PatientDetailsBarTabs = ({ patient, value, onChange, classes }) => (
  <Toolbar
    disableGutters
    className={classes.root}
  >
    <Tabs
      value={value}
      {...onChange ? { onChange } : {}}
      indicatorColor="primary"
      textColor="primary"
    >
      <Tab label="Profile" value="profile" />
      <Tab label="Orders" value="summary" />
      {/*<Tab label="History" value="history" />*/}
    </Tabs>
    <Link
      className={classes.link}
      color="primary"
      bold
      size="lg"
      href={`/workflow/order/create/patient/${patient['Record Number']}`}
      target="_blank"
    >
      <IconPlus className={classes.iconPlus} />
      Create Order
    </Link>
  </Toolbar>
);

PatientDetailsBarTabs.propTypes = {
  patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  value: PropTypes.oneOf(['summary', 'profile', 'history']),
  onChange: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

PatientDetailsBarTabs.defaultProps = {
  value: 'summary',
  onChange: null,
};

export default withStyles(styles)(PatientDetailsBarTabs);



// WEBPACK FOOTER //
// ./src/components/patient/PatientDetailsBar/PatientDetailsBarTabs.js